<app-heading [breadcrumbTitleOptions]="breadcrumbTitleOptions" [title]="'Profile Documents'" [button]="false" [isbreadcrumb]="isPwcEnabled && from() === 'onboarding' ? false : true" [showToggle]="false"></app-heading>

<div class="flex flex-column gap-4">
    <div class="flex align-items-center justify-content-between">
        <span class="h6">Resume</span>
        @if(!resume){
                <div class="flex align-items-center gap-2">
                @if(isPwcEnabled){
                    <span>PDF files Only</span>
                }
                <input type="file" [attr.accept]="isPwcEnabled ? 'application/pdf' : null" #resumeInput style="display: none" (change)="onUploadDocument($event, 'RESUME')">
                <p-button (click)="resumeInput.click()" label="{{isMobileFromCookie? 'add': 'add resume'}}" rounded="true" size="large"
                    icon="pi pi-plus"></p-button>
            </div>
        }
    </div>

    @if(resume && resume.url){

    <div class="w-full">
        <div class="align-items-center border-bottom-1 flex justify-content-between p-2 surface-border">
            <div class="flex flex-column">
                <span>{{resume.title}}</span>
            </div>
            <div class="flex">
                <p-button pTooltip="Download"
                tooltipPosition="top" (onClick)="downloadDocument(resume)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                </p-button>
                <input type="file" [attr.accept]="isPwcEnabled ? 'application/pdf' : null" #resumeEdit style="display: none" (change)="editDocument($event, 'RESUME', resume)">
                <p-button pTooltip="Edit"
                tooltipPosition="top"  (click)="resumeEdit.click()" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                </p-button>
                <p-button pTooltip="Delete"
                tooltipPosition="top" (onClick)="deleteDocment(resume._id,false)" [rounded]="true" [text]="true" icon="true">
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                </p-button>
            </div>
        </div>
    </div>
    }


    <div class="flex align-items-center justify-content-between">
        <span class="h6">Certification</span>
        <div class="flex align-items-center gap-2">
            @if(isPwcEnabled){
                <span>PDF files Only</span>
            }
            <input type="file" [attr.accept]="isPwcEnabled ? 'application/pdf' : null" #certificationInput style="display: none" (change)="onUploadDocument($event, 'CERTIFICATION')">
            <p-button (click)="certificationInput.click()" label="{{isMobileFromCookie? 'Add': 'Add Certification'}}" rounded="true" size="large" icon="pi pi-plus"></p-button>
        </div>
    </div>

    @if(certifications && certifications.length > 0){
        @for (certification of certifications; track certification) {
        <div class="w-full">
            <div class="align-items-center border-bottom-1 flex justify-content-between p-2 surface-border">
                <div class="flex flex-column">
                    <span>{{certification.title}}</span>
                </div>
                <div class="flex">
                    <p-button pTooltip="Download"
                    tooltipPosition="top" (onClick)="downloadDocument(certification)" [rounded]="true" [text]="true" icon="true">
                        <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                    </p-button>
                    <input type="file" [attr.accept]="isPwcEnabled ? 'application/pdf' : null" #certificationEdit style="display: none" (change)="editDocument($event, 'CERTIFICATION',certification)">
                    <p-button pTooltip="Edit"
                    tooltipPosition="top" (click)="certificationEdit.click()" [rounded]="true" [text]="true" icon="true">
                        <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                    </p-button>
                    <p-button pTooltip="Delete"
                    tooltipPosition="top"  (onClick)="deleteDocment(certification._id,false)"  [rounded]="true" [text]="true" icon="true">
                        <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                    </p-button>
                </div>
            </div>
        </div>
        }
    }

    @if(!isPwcEnabled){
        <div class="flex align-items-center justify-content-between">
            <span class="h6">{{'Additional Documents' | sentenceCase}}</span>
            <input type="file" [attr.accept]="isPwcEnabled ? 'application/pdf' : null" #documents style="display: none" (change)="onUploadDocument($event, 'ADDITIONAL_DOCUMENT')">
            <p-button  (click)="documents.click()" label="{{isMobileFromCookie? 'add': 'add additional documents'}}"  rounded="true" size="large" icon="pi pi-plus"></p-button>
        </div>
    
        @if(additionalDocuments && additionalDocuments.length > 0){
            @for (ad of additionalDocuments; track ad) {
            <div class="w-full">
                <div class="align-items-center border-bottom-1 flex justify-content-between p-2 surface-border">
                    <div class="flex flex-column">
                        <span>{{ad.title}}</span>
                    </div>
                    <div class="flex">
                        <p-button pTooltip="Download"
                        tooltipPosition="top" (onClick)="downloadDocument(ad)" [rounded]="true" [text]="true" icon="true">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                        </p-button>
                        <input type="file" [attr.accept]="isPwcEnabled ? 'application/pdf' : null" #editDocu style="display: none" (change)="editDocument($event, 'ADDITIONAL_DOCUMENT',ad)">
                        <p-button pTooltip="Edit"
                        tooltipPosition="top" (click)="editDocu.click()" [rounded]="true" [text]="true" icon="true">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                        </p-button>
                        <p-button pTooltip="Delete"
                        tooltipPosition="top" (onClick)="deleteDocment(ad._id,false)"  [rounded]="true" [text]="true" icon="true">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                        </p-button>
                    </div>
                </div>
            </div>
            }
        }
    }
</div>

<div class="flex gap-3 mt-3">
    <p-button label="back" rounded="true" outlined="true" size="large"
        styleClass="white-space-nowrap" (onClick)="onBack()"></p-button>
    @if(from() === 'onboarding' && isPWCEnabled){
        <p-button label="next" rounded="true" size="large"
            styleClass="white-space-nowrap" (onClick)="onNext()" [disabled]="!resume && !certifications.length"></p-button>
    }
</div>
